import { OnInit, Input, OnDestroy } from "@angular/core";
import { FormGroup } from '@angular/forms';
import { SetService, HttpService, PageService, JwtService } from 'ngx-block-core';
import { filter, distinctUntilChanged, debounceTime } from 'rxjs/operators';

export interface BaseBlockClass {
    acl: string;
    local: boolean;
    static: boolean;
    blockid: string;
    layoutid: string;
    sets: any;
    staticSets: {
        eventDatas: any,
        generateDatas: any,
        baseDatas: any,
        formDatas: any,
        otherDatas: any
    };
    setData: any[];
}

export interface FormBlockClass extends BaseBlockClass {
    form: FormGroup;
    nzFormGroupData: any;
    nzLayout: string;
    formDataInit();
    valueChangeSubscribe();
}


/**
 * 一般来说，应用无需关注此类
 */
export abstract class BaseComponent implements OnInit, OnDestroy {
    private _timerCache = [];

    /**
     * 延迟一会再执行一些逻辑，用法和`setTimeout`一模一样，差别在于更加安全，当组件被销毁了后，
     * `setTimeout`里已经设置的逻辑依然会被执行，这在某些特定情况下会造成意外，从而造成组件出错。
     * 使用本方法启动的异步逻辑在组件销毁之后，不再被执行。
     */
    protected callLater(handler: Function);

    protected callLater(handler: Function, timeout: number);

    protected callLater(handler: Function, context: any);

    protected callLater(handler: Function, context: any, timeout: number);

    protected callLater(handler: Function, contextOrTimeout: any | number = undefined, timeout: number = 0): any {
        if (!this._timerCache) {
            // maybe this object has been destroyed!
            return;
        }
        if (typeof contextOrTimeout === 'number') {
            timeout = +contextOrTimeout;
            contextOrTimeout = null;
        }

        const timer = setTimeout(() => {
            if (!this._timerCache) {
                // maybe this object has been destroyed!
                return;
            }
            const idx = this._timerCache.indexOf(timer);
            if (idx != -1) {
                this._timerCache.splice(idx, 1);
            }
            this.safeInvokeCallback(contextOrTimeout, handler);
        }, timeout);
        this._timerCache.push(timer);
        return timer;
    }

    /**
     * 终止`callLater`所发起的异步任务，用法与`clearTimeout`非常类似，但是更加安全，
     * 可以顺便将`callLater`所缓存的定时器序号删除。
     *
     */
    protected clearCallLater(handle: number): void {
        clearTimeout(handle);

        if (!this._timerCache) {
            return;
        }
        const idx = this._timerCache.indexOf(handle);
        if (idx != -1) {
            this._timerCache.splice(idx, 1);
        }
    }

    ngOnInit() {
        console.log("AbstractJigsawViewBase", 'init');
    }

    ngOnDestroy() {
        console.log("AbstractJigsawViewBase", 'ngOnDestroy');
        this._timerCache.forEach(t => clearTimeout(t));
        this._timerCache = null;
    }

    /**
     * 安全的调用一个函数，并返回该函数的返回值。如果该函数执行失败，可以在控制台给出实际的堆栈以协助排查问题
     *
     * @param context 执行函数的上下文
     */
    public safeInvokeCallback(context: any, callback: Function, args?: any[]): any {
        if (this.isUndefined(callback)) {
            return;
        }
        try {
            return callback.apply(context, args);
        } catch (e) {
            console.error('invoke callback error: ' + e);
            console.error(e.stack);
        }
    }
    /**
     * 参考 `isDefined`
     *
     * @param value
     */
    public isUndefined(value): boolean {
        return !this.isDefined(value);
    }
    /**
     * 可靠的判断一个值是否有效，输入 `""` 和 `0` 均返回true，只有`null`或者`undefined`才会返回false
     *
     * @param value 待测验的值
     */
    public isDefined(value): boolean {
        return value !== undefined && value !== null;
    }

}

export abstract class BlockBaseComponent extends BaseComponent implements FormBlockClass {

    protected _sets: any;

    @Input()
    public get sets(): any {
        return this._sets;
    }
    public set sets(sets: any) {
        if (typeof sets == "string")
            this._sets = JSON.parse(<any>sets);
        else
            this._sets = sets
    }

    @Input() acl: string = "";
    @Input() local: boolean = false;
    @Input() static: boolean = false;
    @Input() blockid: string = "-1";
    @Input() layoutid: string = "-1";
    @Input() form: FormGroup;
    @Input() nzFormGroupData: any;
    @Input() nzLayout: string = 'horizontal';

    staticSets: { eventDatas: any; generateDatas: any; baseDatas: any; formDatas: any; otherDatas: any; } =
        {
            eventDatas: null,
            generateDatas: null,
            baseDatas: null,
            formDatas: null,
            otherDatas: null,
        };
    setData = [];

    constructor(
        public setService: SetService,
        protected pageService: PageService,
        protected jwtService: JwtService,
        protected http: HttpService,
    ) {
        super();
    }

    ngOnInit(): void {
        super.ngOnInit();
        console.log("BlockBaseComponent", 'ngOnInit')
        this.baseInit();
        this.valueChangeSubscribe();
    }

    baseInit() {
        if (!this.local) {//非本地
            if (!this.static) {//非静态
                if (this.setService.blocksort[this.blockid]['sets'] !== "{}") {
                    this.sets = this.setService.blocksort[this.blockid]['sets'];
                } else {
                    this.setService.blocksort[this.blockid]['sets'] = this.sets;
                }
                console.log("sets", this.sets, this.blockid)

                this.sets.blockId = this.blockid;
                this.sets.layoutId = this.layoutid;
                this.autoUpdate();
                this.otherInPzInit();
                this.formDataInit();
                // this.safeInvokeCallback(this, this.setDataInit)
                this.setDataInit();
                console.log("aftersetDataInit", this.setData);
                if (typeof this.setService.setDatas[this.blockid] == 'undefined') {
                    this.setService.setDatas[this.blockid] = this.setData;
                }
                this.pzListening();
            }
            else {//静态
                this.blockid = this.sets.blockId;
                this.layoutid = this.sets.layoutId;
                this.autoUpdate();
            }
            this.Listening();
        }
    }
    otherInPzInit() {

    }

    /** 配置数组自动更新方法 */
    abstract autoUpdate();
    /** 配置面板数据设置 */
    abstract setDataInit();
    /** 表单数据变化时具体执行的方法 */
    abstract doValueChange(val);

    /** 表单配置时初始化，包括设置数据类型、设置搜索方式 */
    formDataInit() {
        if (this.isDefined(this.nzFormGroupData) && this.isDefined(this.staticSets.formDatas)) {
            try {
                this.nzFormGroupData['nzSearchDataType'] = this.staticSets.formDatas['nzSearchDataType'];
                if (this.nzFormGroupData['nzSearchType'] == 'null')
                    this.nzFormGroupData['nzSearchType'] = this.staticSets.formDatas['nzSearchType'];;
                if (this.sets.styles.nzNoSee == true)
                    this.nzFormGroupData['nzSearchDataType'] = "noSee";
            } catch (error) {
                console.error('formDataInit error: ', error, this.sets['blockName'], this.blockid);
            }
        }

    }

    /** 表单值变化监听 */
    valueChangeSubscribe() {
        if (this.isDefined(this.nzFormGroupData)) {
            this.form.get(this.nzFormGroupData.nzKey).valueChanges.pipe(
                //同valueChanges，不写也可
                filter(val => this.isDefined(val)),
                distinctUntilChanged(),
                //防抖时间，单位毫秒
                debounceTime(this.isDefined(this.sets.styles['nzDebounceTime']) ? this.sets.styles['nzDebounceTime'] : 0),
            ).subscribe((val) => {
                console.log("change", val, this.sets['blockName'], this.blockid)
                // this.safeInvokeCallback(this, this.doValueChange, [val])
                this.doValueChange(val);
            });
            //附加操作，设置只读属性
            console.log('nzReadOnly', this.sets.blockName, this.sets.styles.nzReadOnly);
            if (this.sets.styles.nzReadOnly) {
                console.log('disable', this.sets.blockName);
                this.form.get(this.nzFormGroupData.nzKey).disable();
            } else {
                console.log('enable', this.sets.blockName);
                this.form.get(this.nzFormGroupData.nzKey).enable();
            }
        }
    }

    /**
     * 配置时的监听，只会发生在工具配置时
     */
    pzListening() {
        this.callLater(() => {
            this.setService.initEvent(this.blockid, 'pz');
            this.setService.pzEvents[this.blockid].subscribe(
                data => {
                    console.log('pzListening', data['type'], this)
                    // this.safeInvokeCallback(this, this.pzSwitchFn, [data])
                    this.pzSwitchFn(data);
                }
            )
        }, 100)
    }
    /** 配置时的监听具体执行的方法 */
    abstract pzSwitchFn(data);

    /**
     * 使用时的监听
     */
    Listening() {
        console.log("Listening-input", this.blockid)
        this.callLater(() => {
            this.setService.initEvent(this.blockid);
            this.setService.events[this.blockid].subscribe(
                data => {
                    console.log("Listeningdata-input22", data, this)
                    // this.safeInvokeCallback(this, this.switchFn, [data])
                    this.switchFn(data);
                }
            )

        }, !this.static ? 100 : 0);
    }
    /** 使用时的监听执行的具体方法 */
    abstract switchFn(data);

    ngOnDestroy() {
        super.ngOnDestroy();
        console.log("FormBlockComponent", 'ngOnDestroy')
        this.setService.deleteEvent(this.blockid);
        if (!this.static)
            this.setService.deleteEvent(this.blockid, 'pz')
    }

}

